<div class="pop-up-container">
  <span (click)="togglePopUp()" class="text-pop-up-toggle-container">
    <ng-content select="[textPopUpOpen]"></ng-content>
  </span>

  <div [ngClass]="['text-pop-up']" *ngIf="show" #dragDiv>
    <div #header class="pop-up-header">
      <span (click)="togglePopUp()">&times;</span>
    </div>

    <div class="pop-up-body">
      <ng-content select="[textPopUpContent]"></ng-content>
    </div>
  </div>
</div>